// routes
import { PATH_DASHBOARD } from './routes/paths';

// General
export const APP_VERSION = import.meta.env.VITE_APP_VERSION
export const APP_ENV = import.meta.env.VITE_ENV

// API
// ----------------------------------------------------------------------
export const BASE_URL = import.meta.env.VITE_BASE_URL;

// API
// ----------------------------------------------------------------------
export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS;
export const HELIOS_API_TOKEN = import.meta.env.VITE_HELIOS_API_TOKEN;

// AWS
// ----------------------------------------------------------------------
export const AWS_CLOUDFROND_BASE_URL = import.meta.env.VITE_AWS_CLOUDFROND_BASE_URL;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.main;
// export const PATH_AFTER_LOGIN = PATH_DASHBOARD.sub.root;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};

// PAYMENT
export const LOCAL_TRANS_FEE = 1.1
export const REFUND_FEE_PERCENTAGE = 5

// CASHIER
// ----------------------------------------------------------------------
export const CASHIER_PRICE_OVERRIDE_PIN = '343686';

// ========================================
// INACTIVITY LOGOUT CONFIGURATION
// ========================================

/**
 * Inactivity timeout before auto-logout (in minutes)
 * Default: 30 minutes
 * TESTING: 20 minutes
 *
 * This timer resets on any user interaction:
 * - Mouse movement, clicks, keyboard input
 * - Touch events (mobile)
 * - Scroll events
 * - Route changes
 *
 * Note: Converted to milliseconds in useInactivityLogout hook
 */
export const INACTIVITY_TIMEOUT_MINUTES = 20; // TESTING: 20 minutes (production: 30)

/**
 * Warning period before actual logout (in minutes)
 * Default: 2 minutes
 *
 * User will see a warning dialog this many minutes before logout.
 * They can click "Stay Logged In" to reset the timer.
 *
 * Note: Converted to milliseconds in useInactivityLogout hook
 */
export const INACTIVITY_WARNING_MINUTES = 2;

/**
 * Debounce delay for activity events (in milliseconds)
 * Default: 2000ms
 *
 * Activity events (mouse, keyboard, etc.) are debounced to prevent
 * excessive timer resets and improve performance.
 */
export const ACTIVITY_DEBOUNCE_MS = 2000;

/**
 * Routes to exclude from inactivity logout
 * Users on these routes will NOT be auto-logged out
 */
export const INACTIVITY_EXCLUDED_ROUTES = [
  '/scanner',           // Event scanner pages
  '/seller-scanner',    // Seller scanner pages
];

/**
 * BroadcastChannel name for cross-tab communication
 * Used to sync activity and logout across browser tabs
 */
export const INACTIVITY_CHANNEL_NAME = 'nimi_inactivity_channel';

/**
 * LocalStorage key for cross-tab activity tracking (fallback)
 * Used when BroadcastChannel API is not available
 */
export const INACTIVITY_STORAGE_KEY = 'nimi_last_activity';

/**
 * LocalStorage key for logout broadcast (fallback)
 * Used to trigger logout across all tabs when BroadcastChannel unavailable
 */
export const INACTIVITY_LOGOUT_KEY = 'nimi_logout_broadcast';
